import { JobProvider } from "./state/JobContext";
import { LoadingProvider } from "./state/LoadingContext";
import AppRouter from "./app/routes/AppRouter";
import { ApplicationContextProvider } from "./state/ApplicationContext";

const App = () => (
  <ApplicationContextProvider>
    <JobProvider>
      <LoadingProvider>
        <AppRouter />
      </LoadingProvider>
    </JobProvider>
  </ApplicationContextProvider>
);

export default App;
